'use strict';

var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var factoryWithTypeCheckers = require('prop-types/factoryWithTypeCheckers');
var constants = require('./constants.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _defineProperty__default = /*#__PURE__*/_interopDefaultCompat(_defineProperty);
var factoryWithTypeCheckers__default = /*#__PURE__*/_interopDefaultCompat(factoryWithTypeCheckers);

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var REACT_ELEMENT_TYPE = Symbol.constructor === Function && Symbol["for"] && Symbol["for"]('react.element') || 0xeac7;
var REACT_FORWARD_REF_ELEMENT_TYPE = Symbol.constructor === Function && Symbol["for"] && Symbol["for"]('react.forward_ref') || 0xead0;

var isValidReactElement = function isValidReactElement(element) {
  return element.constructor === Object && (element.$$typeof === REACT_ELEMENT_TYPE || element.$$typeof === REACT_FORWARD_REF_ELEMENT_TYPE);
};

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var toSnakeCase = function toSnakeCase(text) {
  return text.match(/[AZ]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g).map(function (x) {
    return x.toLowerCase();
  }).join('_');
};

var _this = undefined;

/**
 * @license
 * This source code is and remains the property of UserZoom Technologies Inc (sucursal en España).
 * Dissemination of this information or reproduction of this material is strictly
 * forbidden unless prior written permission is obtained from
 * UserZoom Technologies Inc (sucursal en España) (https://www.userzoom.com).
 */
var clone = function clone(element) {
  if (element && !Number.isNaN(element)) {
    var newItem;
    var iterator;

    if (element.constructor === Object) {
      newItem = {};
      iterator = Object.keys(element);
    } else if (Array.isArray(element)) {
      newItem = [];
      iterator = element;
    } else {
      newItem = element;
    }

    if (element.constructor === Object || Array.isArray(element)) {
      iterator.forEach(function (attribute) {
        if (element[attribute].constructor === Object) {
          newItem[attribute] = clone(element[attribute]);
        } else if (Array.isArray(element[attribute])) {
          newItem[attribute] = element[attribute].map(function (each) {
            return clone(each);
          });
        } else {
          newItem[attribute] = element[attribute];
        }
      });
    } else if (element.constructor === Function) {
      var fnBinding = element.bind(_this);
      newItem = Object.assign(fnBinding, element);
    }

    return newItem;
  }

  throw new TypeError('Invalid type, [Number, String, Boolean, Function, Object or Array] types expected.');
};

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty__default["default"](target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var overridePropTypeChecker = function overridePropTypeChecker(propType) {
  var values = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var newPropType = clone(propType);

  newPropType.$$computed = _objectSpread(_objectSpread({}, newPropType.$$computed), values);

  if (newPropType.isRequired) {
    newPropType.isRequired = clone(propType.isRequired);
    newPropType.isRequired.$$computed = _objectSpread(_objectSpread({}, newPropType.isRequired.$$computed), values);
    newPropType.isRequired.$$computed.isRequired = true;
    newPropType.$$computed.isRequired = false;
  }

  return newPropType;
};

var propTypesChecker = factoryWithTypeCheckers__default["default"](isValidReactElement, true);
var PropTypes = Object.keys(constants.PROP_TYPES_INFO).filter(function (each) {
  return each !== 'custom';
}).reduce(function (acc, current) {
  var _objectSpread2;

  return _objectSpread(_objectSpread({}, acc), {}, (_objectSpread2 = {}, _defineProperty__default["default"](_objectSpread2, current, constants.PROP_TYPES_INFO[current].type === constants.PROP_TYPES.FUNCTION ? function (infoFromPropTypes) {
    return overridePropTypeChecker(propTypesChecker[current](infoFromPropTypes), _objectSpread(_objectSpread({}, constants.PROP_TYPES_INFO[current].info), {}, {
      infoFromPropTypes: infoFromPropTypes
    }));
  } : overridePropTypeChecker(propTypesChecker[current], constants.PROP_TYPES_INFO[current].info)), _defineProperty__default["default"](_objectSpread2, "".concat(current, "WithDescription"), function WithDescription() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    if (constants.PROP_TYPES_INFO[current].type === constants.PROP_TYPES.FUNCTION) {
      var infoFromPropTypes = args[0],
          _description = args[1],
          _args$ = args[2],
          _additionalInfo = _args$ === void 0 ? {} : _args$;

      return overridePropTypeChecker(propTypesChecker[current](infoFromPropTypes), _objectSpread(_objectSpread({}, constants.PROP_TYPES_INFO[current].info), {}, {
        description: _description,
        infoFromPropTypes: infoFromPropTypes
      }, _additionalInfo));
    }

    var description = args[0],
        _args$2 = args[1],
        additionalInfo = _args$2 === void 0 ? {} : _args$2;
    return overridePropTypeChecker(propTypesChecker[current], _objectSpread(_objectSpread({}, constants.PROP_TYPES_INFO[current].info), {}, {
      description: description
    }, additionalInfo));
  }), _objectSpread2));
}, {}); // Add custom propType checker

PropTypes.customWithDescription = function (validator, description, additionalInfo) {
  return overridePropTypeChecker(validator, _objectSpread(_objectSpread({}, constants.PROP_TYPES_INFO.custom.info), {}, {
    description: description
  }, additionalInfo));
}; // Export PROP_TYPES_NAMES


PropTypes.PROP_TYPES_NAMES = Object.freeze(Object.keys(constants.PROP_TYPES_INFO).reduce(function (acc, current) {
  return _objectSpread(_objectSpread({}, acc), {}, _defineProperty__default["default"]({}, toSnakeCase(current).toUpperCase(), constants.PROP_TYPES_INFO[current].info.type));
}, {}));
PropTypes.HELPER_ID = 'Gearz.JsUtils.PropTypes';

module.exports = PropTypes;
